import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import PropTypes from "prop-types";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {toast} from "react-toastify";
import {
  requestSensorGroupList,
  sensorGroupTypeSelected,
  updateSensorGroupType,
  requestSensorTypeList,
} from "../../redux/Actions/controllers.actions";
import {getSelectedController} from "../../redux/Selectors/controllers.selectors";
import SelectCreator from "../Forms/components/SelectCreator";
import Loader from "../Loader";

const EditSensorDetailsModal = ({open, onClose, sensorId}) => {
  const dispatch = useDispatch();
  const [groupList, setGroupList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const selectedController = useSelector(getSelectedController);
  const category = selectedController.category;

  useEffect(() => {
    if (category) {
      dispatch(requestSensorGroupList(setGroupList));
      dispatch(requestSensorTypeList(category, setTypeList));
      dispatch(sensorGroupTypeSelected(sensorId, setSelectedGroup, setSelectedType));
    }
  }, [dispatch, category, sensorId]);

  const handleMenuOpen = () => {
    if (!category) {
      toast.error("Inventory doesn't have a valid category");
    }
  };

  const submitHandler = () => {
    const payload = {
      sensorId: sensorId,
      selectedGroup: selectedGroup,
      selectedType: selectedType,
    };
    dispatch(updateSensorGroupType(payload, onClose));
  };

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop="static">
      <Loader />
      <ModalHeader>Edit Sensor Details</ModalHeader>
      <ModalBody>
        <SelectCreator
          label="Select Type"
          placeholder="Select a new type"
          value={selectedType}
          name={"type"}
          options={typeList}
          onChange={(e) => setSelectedType(e.target.value)}
          onMenuOpen={handleMenuOpen}
          large
          classNamePrefix={"select_type"}
          id={"select_type"}
        />
        <SelectCreator
          label="Select Group"
          placeholder="Select a new group"
          value={selectedGroup}
          name={"group"}
          options={groupList}
          onChange={(e) => setSelectedGroup(e.target.value)}
          onMenuOpen={handleMenuOpen}
          large
          classNamePrefix={"select_group"}
          id={"select_group"}
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={submitHandler} data-cy="submit-btn">
          SAVE
        </Button>
        <Button onClick={onClose} data-cy="cancel-btn">
          CANCEL
        </Button>
      </ModalFooter>
    </Modal>
  );
};

EditSensorDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  sensorId: PropTypes.number.isRequired,
};

export default EditSensorDetailsModal;
